<template>
  <div class="_login-app">
    <div class="login">
      <div class="logo-box">
        <div class="content">
          <div class="logo-pic">
            <div class="inner-pic">
              <el-image :src="require('../assets/logo.jpg')"></el-image>
            </div>
          </div>
          <div class="app-title">{{ $store.state.sys.title }}</div>
        </div>
      </div>
      <div class="login-box">
        <el-form ref="form" :model="data" size="large" style="width: 100%;" :rules="rules"
          @keyup.enter.native="login">
          <div class="title">用户登录</div>
          <el-form-item prop="LoginId">
            <el-input prefix-icon="el-icon-user" v-model="data.LoginId" placeholder="请输入账号" />
          </el-form-item>
          <el-form-item prop="Pwd">
            <el-input prefix-icon="el-icon-lock" show-password type="password" v-model="data.Pwd"
              placeholder="请输入密码" />
          </el-form-item>
          <!-- 验证码 -->
          <div style="display: flex;">
            <div style="width: 100%;">
              <el-form-item prop="VerifyCode">
                <el-input  prefix-icon="el-icon-key" v-model="data.VerifyCode" placeholder="请输入验证码" />
              </el-form-item>
            </div>
            <div style="padding-left:10px;">
              <s-identify :identifyCode="identifyCode" @refresh="refreshCode"></s-identify>
            </div>
          </div>
          <el-button size="large" :loading="loading" type="primary" id="login_btn" @click="login">登 录</el-button>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
import sIdentify from "@/components/common/sIdentify";

export default {
  components: { sIdentify },
  data() {
    const validateCode = (rule, value, callback) => {
      if (this.identifyCode !== value) {
        this.data.VerifyCode = "";
        this.refreshCode();
        callback(new Error("请输入正确的验证码"));
      } else {
        callback();
      }
    };
    return {
      api: require("@/api/sy/user").default,
      identifyCode: "",
      loading: false,
      data: {
        LoginId: "",
        Pwd: "",
        Code: "",
        VerifyCode: "",
      },
      time: 0,
      interval: null,
      rules: {
        LoginId: [{ required: true, message: "请输入账号" }],
        Pwd: [{ required: true, message: "请输入密码" }],
        VerifyCode: [
          { required: true, message: "请输入验证码" },
          { validator: validateCode, trigger: "blur" },
        ],
      },
    };
  },
  created() {
    this.refreshCode();
  },
  mounted() {
    this.$store.dispatch("getSysWebSetting");
    let token = localStorage.getItem("token");
    if (token) {
      this.$store.dispatch("refreshToken").then((res) => {
        if (res.Code == 0) {
          this.$router.push("/dashboard").catch((err) => { });
        }
      });
    }
  },
  methods: {
    login() {
      this.$refs.form.validate().then((res) => {
        if (!res) return false;
        this.loading = true;
        console.log(this.data.LoginId);

        this.$store.dispatch("login", this.data).then((res) => {
          this.$store.dispatch('getNumericSetting')
          this.$store.dispatch('getProductSetting')
          this.$store.dispatch('getSaleSetting')
          this.$store.dispatch("getPurchaseSetting");
          this.$store.dispatch("getStockSetting")
          this.$router.push("/dashboard").catch((err) => { });
        }).catch((res) => {
          this.$message.error(res.Msg);
          this.loading = false;
          console.log(res);
        });
      }).catch((res) => {
        console.log(res);
      });
    },
    refreshCode() {
      this.identifyCode = "";
      for (let i = 0; i < 4; i++) {
        this.identifyCode += this.randomNum(0, 9);
      }
    },
    randomNum(min, max) {
      return Math.floor(Math.random() * (max - min) + min);
    },
  },
};
</script>
<style lang="scss">
._login-app {
  height: 100vh;

  @media screen and (min-width: 768px) {
    background-image: url("../assets/bgPic.jpg");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    -moz-background-size: 100% 100%;
  }

  .login {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 780px;
    height: 390px;
    display: flex;
    z-index: 1000;
    border-radius: 12px;
    box-shadow: 2px 2px 12px 0 rgba(0, 0, 0, 0.1);
    overflow: hidden;

    .logo-box {
      background-color: rgba(24, 76, 131, .85);
      width: 50%;
      display: flex;
      align-items: center;
      justify-content: center;

      .content {
        display: flex;
        flex-direction: column;
        align-items: center;

        .logo-pic {
          width: 180px;
          height: 180px;
          overflow: hidden;
          border-radius: 50%;
          background-color: rgba(255, 255, 255, 0.5);
          padding: 10px;

          .inner-pic {
            width: 160px;
            height: 160px;
            overflow: hidden;
            border-radius: 50%;
            background-color: #ffffff;
            padding: 15px;
          }
        }

        .app-title {
          margin-top: 15px;
          height: 40px;
          line-height: 40px;
          font-size: 26px;
          font-weight: bold;
          text-align: center;
          color: #ffffff;
        }
      }
    }

    .login-box {
      width: 50%;
      padding: 0 25px;
      background-color: #fff;
      display: flex;
      align-items: center;

      .title {
        height: 50px;
        font-size: 24px;
        letter-spacing: 1px;
      }
      .el-input {
        font-size: 15px;
        .el-input__inner::placeholder {
          color: #aaa;
        }
        .el-input__inner {
          border: none;
          background: #f5f5f5;
          border-radius: 22px;
          padding-left: 2.5rem;
        }
        .el-input__prefix {
          left: .8rem;
          font-size: 17px;
          color: #aaa;
        }
      }

      #login_btn {
        width:100%;
        font-weight: bold;
        background-color: #457BBD;
        font-size: 18px;
        border-radius: 22px;
      }
    }
  }

}
</style>